var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadScoreEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.532227,
    width: 21,
    height: 22,
    rx: 2,
    fill: "#28519E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2979 12.7891L11.5479 16.5391C11.4072 16.6797 11.2197 16.75 11.0322 16.75C10.8213 16.75 10.6338 16.6797 10.4932 16.5391L6.74316 12.7891C6.43848 12.5078 6.43848 12.0156 6.74316 11.7344C7.02441 11.4297 7.5166 11.4297 7.79785 11.7344L10.2822 14.1953V7C10.2822 6.60156 10.6104 6.27344 11.0088 6.27344C11.3838 6.27344 11.7822 6.60156 11.7822 7V14.1953L14.2432 11.7344C14.5244 11.4297 15.0166 11.4297 15.2979 11.7344C15.6025 12.0156 15.6025 12.5078 15.2979 12.7891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadScoreEnabled);
export default __webpack_public_path__ + "static/media/DownloadScoreEnabled.7718c9181b13cffba15725dd2507bda4.svg";
export { ForwardRef as ReactComponent };